import React, { useContext, useEffect, useState } from "react";
import { DEFAULT_MODEL_EMPLOYEE_XLSX } from "../../../../constants/api";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import {
  getUsersJsonFromListUpdated,
  getUsersJsonPermission,
  createTempModel,
} from "../../../../helpers/employeeHelper";
import { isSameText } from "../../../../helpers";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import * as a from "../../../../constants/api";
import * as h from "../../../../helpers";
import * as r from "../../../../constants/routes";
import ButtonsArea from "../../../../components/Buttons/ButtonsArea";
import FriendlyInfo from "../../../../components/FriendlyInfo";
import InputDragAndDrop from "../../../../components/Inputs/InputDragAndDrop";
import ListUsers from "../../../../components/Lists/ListUsers";
import PageHeader from "../../../../components/Headers/PageHeader";
import PageMain from "../../../../components/Main/PageMain";
import pClasses from "../Users.module.scss";
import RoundButton from "../../../../components/Buttons/RoundButton";
import SessionContext from "../../../../context/sessionContext";
import Spinner from "../../../../components/Spinner";
import Title from "../../../../components/Title";
import useFetch from "../../../../hooks/useFetch";
import { setAnalyticsNumUsersAdded } from "../../../../helpers/analyticsHelpers";
import {
  GA_INFO_NOT_IDENTIFIED,
  GA_USER_TYPE_USER,
} from "../../../../constants/defaults";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
// import AddGroupSelect from "./AddGroupSelect";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";


interface AddGroupSelectProps {
  groupsUsers?: any;
}

interface Group {
  company_uid: string;
  id: number;
  name: string;
  status: string;
}

export default function UserAdd() {
  const history = useNavigate();

  const [newUsers, setNewUsers] = useState<any | null>(null); //useState<string | null>(null);
  const [confirmTop, setConfirmTop] = useState<any | null>(null); //useState<string | null>(null);
  const [_contentBottom, setcontentBottom] = useState<any | null>(null); //useState<string | null>(null);
  const [isListOpen, setListOpen] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [selectedGroupId, setSelectedGroupId] = useState<number>(0);

  const cSessions = useContext(SessionContext);
  const { t } = useTranslation();
  const [, listUserIsLoading, listUserError, listUserFetch, clearError]: any =
    useFetch({
      // TODO show img error upload
      autoInit: false,
    });

  const clearAlerts = () => {
    setError(null);
    clearError();
  };

  const onGroupChange = (groupId: number) => {
    const userstoUpdate = newUsers[0];
    userstoUpdate.users.map((item: any) => {
      item.group_uid = groupId;
    });
    userstoUpdate.group_id = groupId;
    setNewUsers([userstoUpdate]);
  };


  const AddGroupSelect: React.FC<AddGroupSelectProps> = ({ groupsUsers = [] }) => {
    const { t } = useTranslation();
    const addGroupSelect = <Select
      style={{ width: "100%", color: "#007085", textAlign: "center" }}
      onChange={(e) => {
        onGroupChange(Number(e.target.value) || 0);
        setSelectedGroupId(Number(e.target.value) || 0);
      }}
      name="group"
      id="group"
      value={selectedGroupId ? groupsUsers?.find((group: Group) => group.id === selectedGroupId)?.id : ""}
      displayEmpty
      disabled={groupsUsers?.length === 0}
    >
      <MenuItem value="">
        {groupsUsers ? t("global.add_all_to_a_group") : t("global.there_are_no_groups_created_to_add_users")}
      </MenuItem>
      {groupsUsers && groupsUsers?.filter((group: Group) => group.status === "active").map((group: Group) => (
        <MenuItem key={group.id} value={group.id}>
          {group.name}
        </MenuItem>
      ))}
    </Select>;

    return <div>{addGroupSelect}</div>;

  }

  const clearUsers = () => {
    setNewUsers(null);
    setcontentBottom(null);
    setConfirmTop(null)
    clearAlerts()
  };
  const postListHandler = () => {
    setConfirmTop(null)
    listUserFetch({
      url: a.API_USERS,
      method: "POST",
      data: newUsers[0],
      onSuccess: () => {
        let numUser = "???";
        if (newUsers) numUser = String(newUsers.length);
        setAnalyticsNumUsersAdded({
          number: numUser,
          company_uid: cSessions.company_uid ?? GA_INFO_NOT_IDENTIFIED,
          user_type: GA_USER_TYPE_USER ?? GA_INFO_NOT_IDENTIFIED,
        });
        history(r.R_A_USERS_LIST_SMART);
      },
    });
  };

  const handleDelete = (postIndex: any) => {
    const filterUser: any = newUsers[0].users
      .filter((f: any, index: any) => index !== postIndex)
      .map((item: any) => item.registry);
    filterUser.forEach((element: any, index: any) => {
      filterUser[index] = [element];
    });
    if (filterUser.length == 0) {
      clearUsers();
      return
    }
    setNewUsersHandler(filterUser);
  };

  const setNewUsersHandler = (list: any) => {
    clearError()
    const newList: any = list.filter((item: any) => item.length > 0);
    const arrayNormalize: any = [];
    newList.forEach((element: any) => {
      arrayNormalize.push(element[0]);
    });
    const arraySet: any = new Set(arrayNormalize);

    if (arraySet.length == 0) {
      return;
    }
    const tempUsers = createTempModel(
      getUsersJsonPermission(),
      getUsersJsonFromListUpdated(arraySet, cSessions.company_uid)
    );
    setNewUsers(tempUsers);
    setLoading(false);
  };
  // let _confirmTop = (

  // );

  function updateRows(newVal: any) {
    const userstoUpdate = newUsers[0];
    userstoUpdate.users.map((item: any, index: any) => {
      if (newVal[index].registry.length > 0) {
        item.registry = newVal[index].registry;
      }
    });
    setNewUsers([userstoUpdate]);
  }


  const [groupsUsers, , , groupsUsersFetch]: any = useFetch({
    autoInit: false,
  });
  useEffect(() => {
    if (cSessions.company_uid) {
      groupsUsersFetch({ url: a.API_USERS_GROUPS_AUDIOFOCO(cSessions.company_uid) });
    }
  }, [cSessions.company_uid]);

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <div className={pClasses.toolbarAddGroup}>
          <div>
            <GridToolbarFilterButton />
            <GridToolbarExport />
          </div>
          <AddGroupSelect groupsUsers={groupsUsers} />
        </div>
      </GridToolbarContainer>
    );
  }

  useEffect(() => {
    if (_contentBottom == null) {
      setcontentBottom(
        <InputDragAndDrop
          onStartToDrop={clearAlerts}
          afterDropFile={(e: any) => {
            h.xlsxToObject(e, setError, setLoading, setNewUsersHandler);
          }}
        />
      );
    }
  }, [_contentBottom]);


  const [open, setOpen] = React.useState(false);
  const [singleUser, setsingleUser] = React.useState("");
  const [_dialog, setDialog] = React.useState(<></>);
  const topContent = <>
    <div className={pClasses.ConfirmArea}>
      <Title h2 className={pClasses.Subtitle}>
        {t("infos.Confirm_overwritten_with_sent_list")}
      </Title>
      <div className={pClasses.TextArea}>
        {t(
          "infos.If_the_User_ID_is_an_email_an_email_with_the_access_code_will_be_sent_automatically"
        )}
      </div>
      <ButtonsArea>
        <RoundButton
          borderLess
          small
          title={"global.cancel_and_go_back_to_upload"}
          text={"global.cancel"}
          onClick={() => clearUsers()}
        />
        <RoundButton
          small
          title={"Confirmar sobrescrita"}
          text={"Confirmar"}
          onClick={postListHandler}
        />
      </ButtonsArea>
    </div>
    <RoundButton
      center
      // outline
      extraSmall
      aLink
      faIcon={isListOpen ? faCaretDown : faCaretUp}
      mb
      title={"Lista de usuários enviada"}
      text={isListOpen ? "Ocultar lista enviada" : "Exibir lista enviada"}
      onClick={() => {
        setListOpen(!isListOpen);
      }}
    />
  </>

  useEffect(() => {
    if (listUserError) {
      setNewUsers(null)
      let listUserErrorMsg: any = t("infos.something_wrong_try_again");
      const users = listUserError?.data?.users ? listUserError.data.users.join(", ") : "";
      if (listUserError.status === 403) {
        // Replace all spaces except the last one with _
        const msg = listUserError?.data?.message ?? "";
        const lastSpaceIndex = msg.lastIndexOf(" ");
        let replacedMsg = msg;
        if (lastSpaceIndex !== -1) {
          replacedMsg =
            msg.slice(0, lastSpaceIndex).replace(/ /g, "_") +
            msg.slice(lastSpaceIndex);
        }
        listUserErrorMsg = t("infos." + msg.replaceAll(" ", "_")) + " " + users || t("infos.something_went_wrong");
      }
      if (listUserError?.data?.message
        && listUserError?.data?.message?.includes("The user has not a valid name:")) {
        const userNameDiv = (
          <>
            {t("infos.the_name_of_the_user")}
            <span style={{ color: "#007085" }}>
              {listUserError?.data?.message?.split(":")[1]} {" "}
            </span>
            {t("infos.its_not_valid")}
          </>)
        listUserErrorMsg = userNameDiv
      }
      const { message, limit } = listUserError.data ?? {};
      if (message && isSameText(message, a.FILE_MORE_USERS_THAN_LIMIT))
        listUserErrorMsg =
          t("infos.file_has_more_users_than_limit") + " " + (limit ?? "");
      else if (message && isSameText(message, a.MORE_USERS_THAN_YOUR_LIMIT))
        listUserErrorMsg = t("infos.more_users_than_your_limit");
      setcontentBottom(
        <FriendlyInfo className={pClasses.Mt} isError text={listUserErrorMsg} />
      );
    } else if (isLoading || listUserIsLoading) {
      setcontentBottom(<Spinner center />);
    } else if (error) {
      setcontentBottom(
        <FriendlyInfo className={pClasses.Mt} isError text="file_not_loaded" />
      );
    } else if (newUsers) {

      // Setting confirm area
      setConfirmTop(
        topContent
      );
      // Setting the list of new employees at bottom
    }
  }, [listUserError, isListOpen, error, listUserIsLoading, newUsers, singleUser]);

  const configFields: any = {
    registry: {
      editable: true,
      hide: false,
    },
    status: {
      editable: false,
      hide: false,
    },
    remove: {
      editable: false,
      hide: false,
    },
  };

  useEffect(() => {
    if (isListOpen && newUsers) {
      clearError()
      setConfirmTop(
        topContent
      );
      setcontentBottom(
        <>
          <ListUsers
            companyUid={cSessions.company_uid}
            users={newUsers[0].users}
            hideFilter
            configFields={configFields}
            callback={updateRows}
            CustomToolbar={CustomToolbar}
            handleDelete={handleDelete}
            setHasUserChangedGroup={() => { }}
          />
        </>
      );
    }
  }, [newUsers, isListOpen]);

  let userUpdateClasses = pClasses.Users;
  if (!newUsers && !listUserError) userUpdateClasses += " " + pClasses.Center;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function setSingleUsersHandler(user: any) {
    clearError()

    if (user.length == 0) {
      return alert(t("userProfile.insertId"));
    }

    const tmpUser = [user];
    const tempUsers: any = createTempModel(
      getUsersJsonPermission(),
      getUsersJsonFromListUpdated(tmpUser, cSessions.company_uid)
    );
    if (newUsers) {
      const haveRegistry: boolean = newUsers[0].users.reduce(
        (haveRegister: boolean, item: any) => {
          return haveRegister || item.registry == user;
        },
        false
      );

      if (haveRegistry) {
        return alert(t("userProfile.haveRegister"));
      }
      const newTempUsers: any = [...newUsers];
      newTempUsers[0].users = [...newUsers[0].users, ...tempUsers[0].users];
      setNewUsers(newTempUsers);
    } else {
      setNewUsers(tempUsers);
    }
    setsingleUser("");
    setLoading(false);
    handleClose();
  }

  useEffect(() => {

    setDialog(
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{t("global.signup")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("userProfile.add_single_user_info")}
          </DialogContentText>
          <TextField
            autoFocus
            required
            error={(singleUser.length == 0)}
            margin="dense"
            id="name"
            label="ID"
            type="email"
            onChange={(v) => setsingleUser(v.target.value)}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            {t("global.close")}
          </Button>
          <Button
            onClick={() => setSingleUsersHandler(singleUser)}
            color="primary"
          >
            {t("global.signup")}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }, [singleUser, open]);

  return (
    <>
      <PageHeader
        title={"Cadastrar Usuários"}
        subtitle={"Envie uma nova lista para cadastrar mais usuários"}
        btnText={"Baixar Modelo"}
        btnTitle={"Utilizar este modelo ao subir a lista"}
        btnDownloadFile={!newUsers ? DEFAULT_MODEL_EMPLOYEE_XLSX : null}
        companyId={cSessions.company_uid}
      />
      <RoundButton
        small
        text={t("global.add_single_user")}
        title={t("global.add_single_user")}
        type={"submit"}
        onClick={handleClickOpen}
      />
      {_dialog}
      <PageMain className={userUpdateClasses}>
        {confirmTop}
        {_contentBottom}
        {listUserError?.status ? <ButtonsArea><RoundButton
          small
          title={"global.cancel_and_go_back_to_upload"}
          text={"global.cancel"}
          onClick={() => clearUsers()}
        /> </ButtonsArea> : null}
      </PageMain>
    </>
  );
}
